import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  Divider,
  List,
  ListItem,
  ListItemText,
  Stack,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";



const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  p: 3,
  maxHeight: "80vh",
  overflowY: "auto",
};

export default function OrderModal({ open, onClose, order }) {
  if (!order) return null;

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        {/* Header */}
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Order Details</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Stack>

        <Divider sx={{ my: 2 }} />

        
        <Stack direction="row" justifyContent="space-between" sx={{ mb: 2 }}>
          <Typography variant="body1">
            Cart: {order.cart?.cart_number || "-"}
          </Typography>
          <Typography variant="body1">
            Txn: {order.cart?.transaction_id || "-"}
          </Typography>
        </Stack>
        <Typography variant="h6" sx={{ mb: 1 }}>
          Customer Details
        </Typography>
        <Box sx={{display:'flex',flexDirection:'row'}}>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          Name :
        </Typography>
           <Typography variant="subtitle2" sx={{ mb: 1 }}>
        {  order.cart?.customerDetails?.first_name}
        </Typography>
        </Box>

        <Box sx={{display:'flex',flexDirection:'row'}}>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          Email :
        </Typography>
           <Typography variant="subtitle2" sx={{ mb: 1 }}>
        {  order.cart?.customerDetails?.email}
        </Typography>
        </Box>


        <Box sx={{display:'flex',flexDirection:'row'}}>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          Contact no :
        </Typography>
           <Typography variant="subtitle2" sx={{ mb: 1 }}>
        {  order.cart?.customerDetails?.phone_number}
        </Typography>
        </Box>

          <Box sx={{display:'flex',flexDirection:'row'}}>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          Pincode :
        </Typography>
           <Typography variant="subtitle2" sx={{ mb: 1 }}>
        {  order.cart?.customerDetails?.pincode}
        </Typography>
        </Box>

          <Box sx={{display:'flex',flexDirection:'row'}}>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          State :
        </Typography>
           <Typography variant="subtitle2" sx={{ mb: 1 }}>
        {  order.cart?.customerDetails?.state}
        </Typography>
        </Box>

          <Box sx={{display:'flex',flexDirection:'row'}}>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          Street :
        </Typography>
           <Typography variant="subtitle2" sx={{ mb: 1 }}>
        {  order.cart?.customerDetails?.street}
        </Typography>
        </Box>
         

       

       
        <Typography variant="h6" sx={{ mb: 0 }}>
          Products
        </Typography>
        {/* <List dense>
          {order.items?.map((item) => (
            <ListItem key={item.cart_item_id} disableGutters>
              <ListItemText
                primary={`${item.product?.name || "Unknown"}`}
                secondary={`Qty: ${item.quantity}  |  Price: ₹${item.price}`}
                
              />
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                ₹{item.price * item.quantity}
              </Typography>
                  

            </ListItem>
            
          ))}
        </List> */}

        <List dense>
  {order.items?.map((item) => (
    <ListItem
      key={item.cart_item_id}
      disableGutters
      sx={{ flexDirection: "column", alignItems: "flex-start", mb: 2 }}
    >
      {/* Text content */}
      <ListItemText
        primary={item.product?.name || "Unknown"}
        secondary={`Qty: ${item.quantity}  |  Price: ₹${item.price}`}
      />
      
      {/* Total price */}
      <Typography variant="body2" sx={{ fontWeight: 600, mt: 1 }}>
        ₹{item.price * item.quantity}
      </Typography>

      {/* Image below everything */}
     <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mt: 1 }}>
        {item.product?.images?.map((imgUrl, index) => (
          <img
            key={index}
            src={imgUrl}
            alt={`product-img-${index}`}
            style={{
              width: 80,
              height: 80,
              objectFit: "cover",
              borderRadius: 6,
            }}
          />
        ))}
      </Box>
    </ListItem>
  ))}
</List>

        <Divider sx={{ my: 2 }} />

        
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="h6">Total</Typography>
          <Typography variant="h6">₹{order.total_amount}</Typography>
        </Stack>

      
    
      </Box>
    </Modal>
  );
}
